import React from "react";

function SomethingWentWrong({errors}) {
  return (
    <div className="ds-container">
      <div className="grid">
        <div className="ds-card ds-fullPagePrompt">
          <div className="cardSection _eventPrompt">
            <i className="materialIcon --large -primary"> cancel </i>
            <h1 className="subhead"> Oops... </h1>
            <p className="copy">
              Looks like something went wrong.
              Please try again later or contact our support team
            </p>
          </div>
          <button className="ds-btn --full" onClick={() => window.location.reload()}> Reload Page </button>
        </div>
      </div>
    </div>
  )
}

export default SomethingWentWrong;



// WEBPACK FOOTER //
// ./src/features/shared/components/notices/SomethingWentWrong.js